<template>
  <Layout :config="config" class="kcsz" v-loading="loading">
    <template v-slot:header>
      <Header
        :config="config.navMenuConfig"
        :menus="config.menuList"
        :menuClass="menuClass"
        v-if="flag"
      />
      <div class="menuBox pc menu-container">
        <NavMenu
          class="nav-menu"
          :config="config.navMenuConfig"
          :menus="config.menuList"
          :menuClass="menuClass"
          v-if="flag"
        />
      </div>
    </template>

    <template v-slot:main>
      <router-view class="main-content"></router-view>
    </template>

    <template v-slot:footer>
      <Footer />
    </template>
  </Layout>
</template>

<script>
import "../plugins/element/element.js";
import utilRouter from "@/libs/util.router.js";
import Layout from "@/components/Layout.vue";
import NavMenu from "@/components/NavMenu.vue";
// import { getMenuList } from "@/api/api.js";
import Header from "./Header.vue";
import Footer from "./Footer.vue";
import util from "@/libs/util.js";
import config from "../config.js";
export default {
  name: "Page",
  data() {
    return {
      config: {},
      menuClass: "subMenuClass",
      list: null,
      loading: false,
      flag: false,
      menuList: [],
    };
  },
  created() {
    util.setIcon("https://www.qau.edu.cn/template/zhuye/ndzy/static/assets/img/ndzy/favicon.ico", "课程思政教学研究中心");
          this.getMenu();
    
    // if (config.menuList.length === 0) {
    //   this.loading = true;
    //   getMenuList({ relationId: 2679, relationType: 1, ishide: 0 })
    //     .then((res) => {
    //       this.list = res;
    //       this.loading = false;
    //     })
    //     .catch((res) => {
    //       console.log(res);
    //       this.loading = false;
    //     });
    // }
  },
  methods: {
    getMenu() {
      // let arr = [];
      // this.menuList = [];
      // this.list.forEach((item) => {
      //     if(item.type ==2){
      //        arr.push({
      //             title: item.title,
      //             type: item.type,
      //             content: item.url,
      //             subMenuList: [],
      //             isActive: config.isNewsActive({
      //               menuId: item.menuId,
      //               type: 0,
      //               articalId: 0,
      //             }),
      //           });
      //     }else{
      //       if(item.menuId==1996){
      //         arr.push({
      //       title: item.title,
      //       type: 1,
      //       content: `/kcsz/news/${item.menuId}?type=${item.type}`,
      //       subMenuList: [],
      //       isActive: config.isNewsActive({
      //         menuId: item.menuId,
      //         type: item.type,
      //         articalId: 0,
      //       }),
      //     });
      //       }else{
      //         arr.push({
      //       title: item.title,
      //       type: 1,
      //       content: `/kcsz/news/${item.menuId}?type=2`,
      //       subMenuList: [],
      //       isActive: config.isNewsActive({
      //         menuId: item.menuId,
      //         type: 2,
      //         articalId: 0,
      //       }),
      //     });
      //     }
             
      //     }
      //     });
      // arr.forEach((item) => {
      //   config.menuList.push(item);
      // });
      config.menuList.unshift({
        title: "首页",
        type: 1,
        content: "/kcsz/portal",
        isActive: utilRouter.isPathActive,
        subMenuList: [],
      });
      config.menuList.splice(1, 0, {
        title: "校内动态",
        type: 1,
        content: "/kcsz/campusDynamic",
        isActive: config.isCampusDynamicActive(1),
        subMenuList: [],
      });
      config.menuList.splice(2, 0, {
        title: "教学案例",
        type: 1,
        content: "/kcsz/news/2505?type=1",
        isActive: config.isCampusDynamicActive(1),
        subMenuList: [],
      });
      config.menuList.splice(3, 0, {
        title: "成果展示",
        type: 1,
        content: "/kcsz/resultsShow",
        isActive: config.isResultsShowActive(2),
        subMenuList: [],
      });
       config.menuList.splice(4, 0, {
        title: "理论武装",
        type: 1,
        content: "/kcsz/news/2506?type=2",
        isActive: config.isResultsShowActive(1),
        subMenuList: [],
      });
       config.menuList.splice(5, 0, {
        title: "云端资源",
        type: 2,
        content: "http://rm.ulearning.cn/#/portal/1745",
        isActive: config.isResultsShowActive(2),
        subMenuList: [],
      });
       config.menuList.splice(6, 0, {
        title: "制度文件",
        type: 1,
        content: "/kcsz/systemFile",
        isActive: config.isSystemFileShowActive(1),
        subMenuList: [],
      });
      this.config = config;
      console.log(this.config,'config');
      this.flag = true;
    },
  },
  components: {
    Layout,
    NavMenu,
    Header,
    Footer,
  },
};
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
@import "../variables.scss";
// @import "@/assets/font_1589680_w5il09oag4/iconfont.css";
.banner {
  display: block;
  height: 200px;
  background-color: rgb(211, 220, 230);
}
.menu-container {
  background-color:#b72f33;
  height: 50px;
  line-height: 50px;
}
.menuBox {
  font-size: 16px;
}
.nav-menu {
  position: relative;
  margin: 0px auto 0;
  // border-radius: 4px;
  background-color: #b72f33;
  /deep/.menu-item:hover {
    font-weight: bold;
    background-color: $menu-hoverColor !important;
    color: #b72f33 !important;
  }
  /deep/.menu-item.is-active {
    font-weight: bold;
    border: unset;
    background-color: $menu-activeColor !important;
     color: #b72f33 !important;
  }
  /deep/.menu-item:hover .el-submenu__title {
    background-color: $menu-hoverColor !important;
     color: #b72f33 !important;
  }
  /deep/.menu-item.is-active .el-submenu__title {
    font-weight: bold;
    border: unset !important;
    background-color: $menu-activeColor !important;
     color: #b72f33 !important;
  }
}
/deep/ .el-menu-item{
     font-size: 16px;
  }
/deep/ .el-submenu__title{
    font-size: 16px;
  }
.main-content {
  min-height: 100%;
  background-color: #f5f5f5;
  // background-image: url("~@/assets/images/kcsz/topBg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  position: relative;
  overflow-x: hidden;
  margin-top: -30px;
  padding-top: 30px;
}
@media (max-width: 767px) {
  .main-content {
    background-color: #fff;
    background-image: unset;
  }
   /deep/.el-menu {
    background-color: $menumobile-activeColor !important;
  }
   /deep/.menu-item{
     background-color: $menumobile-activeColor !important;
  }
   /deep/.menu .menu-item.is-active {
    font-weight: bold;
    border: unset;
    background-color:$menumobile-activeColor  !important;
    color: $menumobile-activeTextColor !important;
  }
   /deep/.menu .menu-item:hover .el-submenu__title {
    background-color:$menumobile-activeColor !important;
    color: #888 !important;
  }
   /deep/.menu .menu-item {
    color: #888 !important;
  }
   /deep/.menu .menu-item.is-active .el-submenu__title {
    font-weight: bold;
    border: unset !important;
    background-color: $menumobile-activeColor !important;
    color:$menumobile-activeTextColor !important;
  }
   /deep/.el-submenu .el-menu-item {
    background-color: $menumobile-activeColor !important;
    color: #888 !important;
    height: 48px;
    line-height: 48px;
  }
  /deep/.menu .menu-item .el-submenu__title {
    background-color: $menumobile-activeColor !important;
    color: #888 !important;
  }
}
</style>
<style lang="scss">
@import "../variables.scss";
.subMenuClass .menu-item.is-active {
  background-color: $menu-activeColor !important;
}
.subMenuClass .menu-item:hover {
  background-color: $menu-hoverColor !important;
}
// 公共样式
.kcsz {
  .can-click:hover .name {
    color: #b92e32;
  }
}

#app .kcsz {
  .el-button--danger {
    color: #fff;
    background-color: #b92e32;
    border-color: #b92e32;
  }

  .el-button--danger:focus,
  .el-button--danger:hover {
    background-color: #b92e32;
    border-color: #b92e32;
    color: #fff;
  }

  .el-button--danger.is-plain {
    color: #b92e32;
    background-color: #f1e9e9;
    border-color: #b92e32;
  }

  .el-button--danger.is-plain:focus,
  .el-button--danger.is-plain:hover {
    background-color: #b92e32;
    border-color: #b92e32;
    color: #fff;
  }

  .el-pager li:hover {
    border-color: #DA2913;
  }

  .el-pager li.active {
    color: #fff;
    border-color: #DA2913;
    background-color: #DA2913;
  }

  .card-shadow {
    box-shadow: 0 2px 8px 0 rgba(96, 30, 30, 0.05);
  }

  .card-shadow.has-hover:hover {
    box-shadow: 0 4px 12px 0 rgba(115, 0, 0, 0.15);
  }
}
</style>
